import React, { useContext } from 'react';
import { Toggle } from '@sekoia/shared/helpers/toggles/Toggle';

export type TogglesContext = Toggle[];
export const TogglesContext = React.createContext<TogglesContext>([]);
export const useTogglesContext = () => useContext(TogglesContext);
